import PropTypes from "prop-types";
import {
  SET_NAV_ACTIVE_ITEM,
  CLEAR_NAV_ACTIVE_ITEM,
  UPDATE_NAVIGATION_TREE
} from "./constants";

const navigationShape = {
  id: PropTypes.string.isRequired,
  alias: PropTypes.string,
  label: PropTypes.string,
  subtitle: PropTypes.string,
  link: PropTypes.string,
  excludes: PropTypes.array.isRequired,
  largeScreenPriority: PropTypes.number,
  smallAndMediumImageUrl: PropTypes.string
};

export const navigationItemPropType = PropTypes.shape(navigationShape);

navigationShape.items = PropTypes.arrayOf(navigationItemPropType).isRequired;

export const navigationPropType = PropTypes.shape(navigationShape);

export {
  setNavActiveItem,
  clearNavActiveItem,
  updateNavigationTree
} from "./actions";
export { UL_ITEM_COUNT } from "./constants";
export {
  maleLargePrimaryNavigationItems,
  femaleLargePrimaryNavigationItems,
  maleSidePrimaryNavigationItems,
  femaleSidePrimaryNavigationItems,
  footerNavigation,
  getNavActiveItem
} from "./selectors";

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_NAV_ACTIVE_ITEM:
      return {
        ...state,
        activeNavItem: payload
      };

    case CLEAR_NAV_ACTIVE_ITEM:
      return {
        ...state,
        activeNavItem: null
      };

    case UPDATE_NAVIGATION_TREE:
      return {
        ...state,
        tree: payload.tree,
        footer: payload.footer
      };
  }

  return state;
};



// WEBPACK FOOTER //
// ./template/state/modules/navigation/index.js